import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BannerService} from '../shared/services/banner.service';
import {NotificationApiService} from '../api/notification-api.service';
import {ChapterNotification} from '../models/notification.model';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

    notifications: ChapterNotification[] = [];
    private dismissedIds = new Set<string>();

    constructor(
        public bannerService: BannerService,
        public router: Router,
        private notificationApiService: NotificationApiService
    ) {
    }

    ngOnInit(): void {
        // Public, unauthenticated feed — safe to call before login/on the landing page.
        this.notificationApiService.getPublic().subscribe({
            next: (notifications) => {
                this.notifications = notifications || [];
            },
            error: () => {
                this.notifications = [];
            }
        });
    }

    get visibleNotifications(): ChapterNotification[] {
        if (!this.bannerService.showBanner) {
            return [];
        }
        return this.notifications.filter(n => !this.dismissedIds.has(n.notificationId));
    }

    get showBanner(): boolean {
        return this.visibleNotifications.length > 0;
    }

    dismissBanner(notification: ChapterNotification): void {
        this.dismissedIds.add(notification.notificationId);
    }

    goToNotification(notification: ChapterNotification): void {
        const targetURL = notification.targetURL;
        this.dismissBanner(notification);
        if (targetURL) {
            this.router.navigateByUrl(targetURL);
        }
    }
}
